// API URLs configuration for Firebase Functions v2
// Each Express API has its own Cloud Run URL

const API_URLS = {
  admin: import.meta.env.VITE_ADMIN_API_URL,
  authWorkspace: import.meta.env.VITE_AUTH_WORKSPACE_API_URL,
  chatMcp: import.meta.env.VITE_CHAT_MCP_API_URL,
  dataManagement: import.meta.env.VITE_DATA_MANAGEMENT_API_URL,
  documentManagement: import.meta.env.VITE_DOCUMENT_MANAGEMENT_API_URL,
  entityManagement: import.meta.env.VITE_ENTITY_MANAGEMENT_API_URL,
  ingestion: import.meta.env.VITE_INGESTION_API_URL,
  migration: import.meta.env.VITE_MIGRATION_API_URL,
  notes: import.meta.env.VITE_NOTES_API_URL,
  processVisibility: import.meta.env.VITE_PROCESS_VISIBILITY_API_URL,
  promptManagement: import.meta.env.VITE_PROMPT_MANAGEMENT_API_URL,
  ptl: import.meta.env.VITE_PTL_API_URL,
  tokenExaminer: import.meta.env.VITE_TOKEN_EXAMINER_API_URL,
  aiReporting: import.meta.env.VITE_AI_REPORTING_API_URL,
  mcp: import.meta.env.VITE_MCP_API_URL,
  userSettings: import.meta.env.VITE_USER_SETTINGS_API_URL,
  slackIngestion: import.meta.env.VITE_SLACK_INGESTION_API_URL,
  slackEvent: import.meta.env.VITE_SLACK_EVENT_API_URL,
  sna: import.meta.env.VITE_SNA_API_URL
};

// Override with emulator URLs when running locally with Firebase emulators
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
  const EMULATOR_BASE = 'http://127.0.0.1:5001/faana-growth-os/us-central1';
  const API_TO_FUNCTION = {
    admin: 'adminApi',
    authWorkspace: 'authWorkspaceApi',
    chatMcp: 'chatMcpApi',
    dataManagement: 'dataManagementApi',
    documentManagement: 'documentManagementApi',
    entityManagement: 'entityManagementApi',
    ingestion: 'ingestionApi',
    migration: 'migrationApi',
    notes: 'notesApi',
    processVisibility: 'processVisibilityApi',
    promptManagement: 'promptManagementApi',
    ptl: 'ptlApi',
    tokenExaminer: 'tokenExaminerApi',
    aiReporting: 'aiReportingApi',
    mcp: 'mcpApi',
    userSettings: 'userSettingsApi',
    slackIngestion: 'slackIngestionApi',
    slackEvent: 'slackEntityApi',
    sna: 'snaApi',
  };
  Object.entries(API_TO_FUNCTION).forEach(([key, fnName]) => {
    API_URLS[key] = `${EMULATOR_BASE}/${fnName}`;
  });
  console.log('API URLs redirected to Firebase emulator (localhost:5001)');
}

// Helper function to get the base URL for a specific API
export const getApiUrl = (apiName) => {
  const url = API_URLS[apiName];
  if (!url) {
    console.error(`No URL configured for API: ${apiName}`);
    // Fallback to legacy URL pattern if needed
    return `${import.meta.env.VITE_FUNCTIONS_BASE_URL}/${apiName}Api`;
  }
  return url;
};

// For backward compatibility - map old function names to new API URLs
export const getFunctionUrl = (functionName) => {
  // Map function names to API categories
  const functionToApi = {
    // Auth & Workspace
    'auth_test': { api: 'authWorkspace', path: '/api/auth/test' },
    'list_workspace_users': { api: 'authWorkspace', path: '/api/auth/workspace/users' },
    'get_user_roles_by_email': { api: 'authWorkspace', path: '/api/auth/users/roles' },
    'get_user_photo': { api: 'authWorkspace', path: '/api/auth/users/photo' },
    'enable_fgos_access': { api: 'authWorkspace', path: '/api/auth/access/enable' },
    'disable_fgos_access': { api: 'authWorkspace', path: '/api/auth/access/disable' },
    'update_entity_user_roles': { api: 'authWorkspace', path: '/api/auth/entities/roles' },

    // Add more mappings as needed...
  };

  const mapping = functionToApi[functionName];
  if (mapping) {
    return getApiUrl(mapping.api) + mapping.path;
  }

  // Fallback for unmapped functions
  console.warn(`No mapping found for function: ${functionName}`);
  return `${import.meta.env.VITE_FUNCTIONS_BASE_URL}/${functionName}`;
};

export default API_URLS;
